import '@/styles/index.css';
import '@/theme/variables';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'component-library';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';

import { navigationService } from '@/config/navigationService';
import { queryClient } from '@/config/queryClient';
import { router } from '@/router';

import { AnalyticsProvider } from './lib/analytics/components/AnalyticsProvider';

navigationService.setNavigate((to) => router.navigate(to));

function App() {
  return (
    <>
      <AnalyticsProvider>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {import.meta.env.SHOW_REACT_QUERY_DEVTOOLS && <ReactQueryDevtools initialIsOpen={false} />}
            <RouterProvider router={router} />
          </QueryClientProvider>
        </HelmetProvider>
        <ToastContainer />
      </AnalyticsProvider>
    </>
  );
}

// eslint-disable-next-line import/no-default-export
export default App;
